import h from 'hyperscript';

export const FEATURE_NAMES = {
    CLIP_PATH: 'clippath'
};

export const supported = name => {
    switch(name) {
        case FEATURE_NAMES.CLIP_PATH:
            return clipPath();

        default:
            return true;
    }
};

export const clipPath = () => {
    const el = <div />;

    if (el.style.clipPath === '') {
        el.style.clipPath = 'url("#foo")';

        return el.style.clipPath !== '';
    }
    
    return false;
};